import { EditableGrid, EditorField } from "@/components/common/EditableGrid";
import { TabContent } from "@/components/common/PageLayout";
import { ShowAccordionSection } from "@/components/common/ShowAccordionSection";
import { ResourceName } from "@/types";
import { validateZipCode } from "@/utils/validators/inPlaceValidators";

export const VendorOverviewTab = () => {
  return (
    <TabContent>
      <ShowAccordionSection label="Vendor Information" defaultExpanded>
        <EditableGrid fields={vendorFields} recordType={ResourceName.VENDORS} />
      </ShowAccordionSection>
    </TabContent>
  );
};

const vendorFields: EditorField[] = [
  // Core Information
  { source: "aegle_id", section: "Core Information" },
  { source: "company_name", section: "Core Information" },
  { source: "group_name", section: "Core Information" },
  { source: "website", section: "Core Information" },
  { source: "category", section: "Core Information" },
  { source: "company_structure", section: "Core Information" },
  { source: "licensed_states", section: "Core Information" },

  // Vendor Type & Capabilities
  {
    source: "is_sl_carrier",
    type: "boolean",
    section: "Vendor Type & Capabilities",
  },
  {
    source: "is_rx_vendor",
    type: "boolean",
    section: "Vendor Type & Capabilities",
  },
  { source: "is_tpa", type: "boolean", section: "Vendor Type & Capabilities" },
  {
    source: "tpa_is_buca",
    type: "boolean",
    showWhen: "is_tpa",
    section: "Vendor Type & Capabilities",
  },
  {
    source: "admin_pp",
    type: "boolean",
    section: "Vendor Type & Capabilities",
  },

  // Company Relationships
  { source: "provider_parent_co", section: "Company Relationships" },
  {
    source: "has_children_co",
    type: "boolean",
    section: "Company Relationships",
  },

  // Carrier Ratings
  {
    source: "financial_strength_rating",
    section: "Carrier Ratings",
    showWhen: "is_sl_carrier",
  },
  {
    source: "long_term_issuer_credit_rating",
    showWhen: "is_sl_carrier",
  },
  {
    source: "outlook",
    showWhen: "is_sl_carrier",
  },
  {
    source: "rating_effective_date",
    type: "date",
    showWhen: "is_sl_carrier",
  },

  // External Identifiers
  { source: "org_id", type: "number", section: "External Identifiers", numberFieldOptions: { useGrouping: false } },
  {
    source: "license_number",
    type: "number",
    section: "External Identifiers",
    numberFieldOptions: { useGrouping: false },
  },
  { source: "fein", type: "number", section: "External Identifiers", numberFieldOptions: { useGrouping: false } },
  { source: "naic_code", type: "number", section: "External Identifiers", numberFieldOptions: { useGrouping: false } },

  // Address Information
  { source: "address.street", section: "Address Information" },
  { source: "address.city", section: "Address Information" },
  { source: "address.state", type: "state", section: "Address Information" },
  { source: "address.zip", section: "Address Information", validate: validateZipCode },

  // Primary Contact
  { source: "primary_contact.name", section: "Primary Contact" },
  { source: "primary_contact.title", section: "Primary Contact" },
  {
    source: "primary_contact.email",
    type: "email",
    section: "Primary Contact",
  },
  {
    source: "primary_contact.phone",
    type: "phone",
    section: "Primary Contact",
  },
  { source: "primary_contact.phone_ext", section: "Primary Contact" },

  // Claims Contact
  { source: "claims_contact.name", section: "Claims Contact" },
  { source: "claims_contact.title", section: "Claims Contact" },
  { source: "claims_contact.email", type: "email", section: "Claims Contact" },
  { source: "claims_contact.phone", type: "phone", section: "Claims Contact" },
  { source: "claims_contact.phone_ext", section: "Claims Contact" },
];
